import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useModalManager } from "../../../../../../context/ModalManager";
import {
  NotificationTypes,
  useNotification,
} from "../../../../../../hooks/useNotification";
import api from "../../../../../../util/api";
import { ExternalAppApiType, QueryKeys } from "../../../../../../util/types";

export const useUpdateExternalApp = () => {
  const { showNotification } = useNotification();
  const { removeLastModal } = useModalManager();
  const queryClient = useQueryClient();

  const { mutateAsync: updateExternalApp, isPending: loading } = useMutation({
    mutationKey: [QueryKeys.EDIT_EXTERNAL_APP],
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: Partial<ExternalAppApiType>;
      customSuccessMessage?: string;
    }) => {
      return await api.updateExternalApp(id, data);
    },
    onSuccess: async (_, variables) => {
      const customSuccessMessage = variables?.customSuccessMessage;
      showNotification(
        customSuccessMessage ?? "Successfully updated",
        NotificationTypes.SUCCESS
      );
      if (customSuccessMessage) {
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.LIST_EXTERNAL_APP],
        });
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.GET_EXTERNAL_APP, variables.id],
        });
        removeLastModal();
      } else {
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.LIST_EXTERNAL_APP],
        });
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.GET_EXTERNAL_APP, variables.id],
        });
      }
    },
    onError: (e: any) => {
      console.error(e);
      showNotification(
        e.error?.message ?? "An error occurred while updating",
        NotificationTypes.WARNING
      );
    },
  });

  return { updateExternalApp, loading };
};
